// Add these variables to track drag state
window.isDragging = false;
window.lastTouchX = 0;
window.lastTouchY = 0;
window.currentBgPosX = 50; // Default background position (%)
window.currentBgPosY = 50; // Default background position (%)
window.touchStartTime = 0;
window.touchMoving = false;

// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
    image.parentElement.classList.add('zoomed-in');
  };

  toggleCarouselDrag(false);

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  // container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithPointer(image, event, zoomRatio) {
  // Get the correct coordinates whether it's touch or mouse
  const clientX = event.clientX || (event.touches && event.touches[0] ? event.touches[0].clientX : null);
  const clientY = event.clientY || (event.touches && event.touches[0] ? event.touches[0].clientY : null);

  // If we don't have valid coordinates, exit
  if (clientX === null || clientY === null) return;

  // calculate pointer position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = clientX - container.left;
  const yPosition = clientY - container.top;

  // Determine if this is a touch event
  const isTouchEvent = event.type.startsWith('touch');

  if (isTouchEvent) {
    // For touch events, implement dragging behavior
    if (event.type === 'touchstart') {
      // Start dragging, record initial position
      window.isDragging = true;
      window.lastTouchX = xPosition;
      window.lastTouchY = yPosition;
      // If this is the first touch, set initial background position to center
      if (window.currentBgPosX === 50 && window.currentBgPosY === 50) {
        overlay.style.backgroundPosition = `50% 50%`;
      }
    } else if (window.isDragging) {
      // Calculate movement delta
      const deltaX = ((xPosition - window.lastTouchX) / image.clientWidth) * 100;
      const deltaY = ((yPosition - window.lastTouchY) / (image.clientWidth * ratio)) * 100;

      // Update position (invert delta for natural dragging feel)
      window.currentBgPosX = Math.max(0, Math.min(100, window.currentBgPosX - deltaX));
      window.currentBgPosY = Math.max(0, Math.min(100, window.currentBgPosY - deltaY));

      // Update last position
      window.lastTouchX = xPosition;
      window.lastTouchY = yPosition;

      // Apply the new position
      overlay.style.backgroundPosition = `${window.currentBgPosX}% ${window.currentBgPosY}%`;
    }
  } else {
    // For mouse events, keep the original hover behavior
    const xPercent = Math.max(0, Math.min(100, xPosition / (image.clientWidth / 100))) + '%';
    const yPercent = Math.max(0, Math.min(100, yPosition / ((image.clientWidth * ratio) / 100))) + '%';

    // Update current position for potential future touch events
    window.currentBgPosX = parseFloat(xPercent);
    window.currentBgPosY = parseFloat(yPercent);

    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  }

  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  window.currentBgPosX = 50;
  window.currentBgPosY = 50;
  window.touchMoving = false;

  const zoomInIcon = document.querySelector('.magnify-zoom-in');
  const zoomOutIcon = document.querySelector('.magnify-zoom-out');

  // Temporarily disable the click handler on the original image
  const originalClickHandler = image.onclick;
  image.onclick = null;

  zoomInIcon.classList.add('hidden');
  zoomOutIcon.classList.remove('hidden');

  const overlay = createOverlay(image);

  // Function to properly clean up the overlay
  const removeOverlay = () => {
    zoomInIcon.classList.remove('hidden');
    zoomOutIcon.classList.add('hidden');

    overlay.remove();

    toggleCarouselDrag(true);

    image.parentElement.classList.remove('zoomed-in');

    // Add a small delay before re-enabling the click handler
    setTimeout(() => {
      image.onclick = originalClickHandler;
    }, 300); // 300ms delay
  };

  // Mouse events
  overlay.onclick = removeOverlay;
  overlay.onmousemove = (event) => moveWithPointer(image, event, zoomRatio);
  overlay.onmouseleave = removeOverlay;

  // Touch events
  overlay.addEventListener(
    'touchstart',
    (event) => {
      // Record the time when touch started
      window.touchStartTime = new Date().getTime();
      window.touchMoving = false;

      // Don't immediately move the pointer on touchstart
      // Just set up the initial tracking variables
      window.isDragging = true;
      const clientX = event.touches[0].clientX;
      const clientY = event.touches[0].clientY;
      const container = event.target.getBoundingClientRect();
      window.lastTouchX = clientX - container.left;
      window.lastTouchY = clientY - container.top;
    },
    { passive: false },
  );

  overlay.addEventListener(
    'touchmove',
    (event) => {
      event.preventDefault(); // Prevent page scrolling
      window.touchMoving = true; // Flag that movement occurred
      moveWithPointer(image, event, zoomRatio);
    },
    { passive: false },
  );

  overlay.addEventListener(
    'touchend',
    (event) => {
      const touchDuration = new Date().getTime() - window.touchStartTime;

      // If touch was short and didn't move much, consider it a tap
      if (touchDuration < 300 && !window.touchMoving) {
        removeOverlay();
      }

      window.isDragging = false;
    },
    { passive: false },
  );
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    // Mouse click handler
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithPointer(image, event, zoomRatio);
    };
  });
}

function toggleCarouselDrag(isEnabled = true) {
  const carousel = document.querySelector('slider-component .flickity-enabled');
  if (carousel) {
    const flkty = Flickity.data(carousel);
    isEnabled ? flkty.bindDrag() : flkty.unbindDrag();
  }
}

enableZoomOnHover(2);
